import type {
  Branch,
  CreateBranchInput,
  CreatePharmacyInput,
  PageResult,
  Pharmacy,
  PharmacyFilterOptions,
  PharmacyListItem,
  PharmacyOverview,
  PharmacyQuery,
  UpdateBranchInput,
  UpdatePharmacyInput,
} from '@quds/shared';
import { apiGet, apiPatch, apiPost } from '@/lib/api';
import { invalidate } from '../invalidation';

/** Pharmacy data service — Central Admin API (search, filters, sorting and paging run on the server). */

export const listPharmacies = (q: PharmacyQuery) =>
  apiGet<PageResult<PharmacyListItem>>('/pharmacies', {
    search: q.search?.trim(),
    country: q.country,
    status: q.status,
    sort: q.sort,
    order: q.order,
    page: q.page,
    pageSize: q.pageSize,
  });

export const getPharmacyFilterOptions = () => apiGet<PharmacyFilterOptions>('/pharmacies/filter-options');
export const getPharmacyOverview = () => apiGet<PharmacyOverview>('/pharmacies/overview');
export const getPharmacy = (id: string) => apiGet<Pharmacy>(`/pharmacies/${encodeURIComponent(id)}`);

export async function createPharmacy(input: CreatePharmacyInput): Promise<Pharmacy> {
  const created = await apiPost<Pharmacy>('/pharmacies', input);
  invalidate();
  return created;
}

export async function updatePharmacy(id: string, input: UpdatePharmacyInput): Promise<Pharmacy> {
  const updated = await apiPatch<Pharmacy>(`/pharmacies/${encodeURIComponent(id)}`, input);
  invalidate();
  return updated;
}

export async function createBranch(businessId: string, input: CreateBranchInput): Promise<Branch> {
  const created = await apiPost<Branch>(`/businesses/${encodeURIComponent(businessId)}/branches`, input);
  invalidate();
  return created;
}

export async function updateBranch(id: string, input: UpdateBranchInput): Promise<Branch> {
  const updated = await apiPatch<Branch>(`/branches/${encodeURIComponent(id)}`, input);
  invalidate();
  return updated;
}
